import React, { useEffect, useState } from 'react'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import MobileIconUi from '../styles/ui/MobileIconUi'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'

type ImageSizeProps = {
  width?: number | string
  mobileWidth?: number | string
  updateWidth: (width: number | string, unit?: string) => void
  updateMobileWidth: (width: number | string, unit?: string) => void
  attrId: string
}

function ImageSize({
  width = 100,
  mobileWidth,
  updateWidth,
  updateMobileWidth,
  attrId,
}: ImageSizeProps) {
  const { isMobile } = useDeviceModeContext()
  const [maxSize, setMaxSize] = useState(0)

  useEffect(() => {
    const imageWrapper = document.getElementById(attrId)
    setMaxSize(
      imageWrapper
        ? Number.parseFloat(
            imageWrapper.getBoundingClientRect().width.toFixed(0),
          )
        : 0,
    )
  }, [isMobile, attrId])

  const isWidthResponsive = isMobile ? mobileWidth === '100%' : width === '100%'

  if (isWidthResponsive) {
    return (
      <CheckboxControl
        label={'entity_settings.image.responsive.label'}
        update={() => updateWidth(maxSize, 'px')}
        mobileUpdate={() =>
          updateMobileWidth(Number(width) < maxSize ? width : maxSize, 'px')
        }
        value={true}
        mobileValue={true}
      />
    )
  }

  return (
    <>
      <CheckboxControl
        label={'entity_settings.image.responsive.label'}
        update={() => updateWidth('100%')}
        mobileUpdate={() => updateMobileWidth('100%')}
        value={false}
        mobileValue={false}
      />
      {isMobile ? (
        <RangeElement
          label="entity_settings.image.size"
          labelIcon={isMobile ? <MobileIconUi /> : null}
          value={
            mobileWidth
              ? typeof mobileWidth === 'string'
                ? Number.parseInt(mobileWidth)
                : mobileWidth
              : Number(width)
          }
          onChange={val => updateMobileWidth(val, 'px')}
          min={1}
          max={maxSize}
        />
      ) : (
        <RangeElement
          label="entity_settings.image.size"
          value={Number(width)}
          onChange={val => updateWidth(val, 'px')}
          min={1}
          max={maxSize}
        />
      )}
    </>
  )
}

export default ImageSize
